/* assets/of-help-article.js (added 2026-08-01, help-center redesign)
 *
 * Article-page controller. Three jobs:
 *   1. Record the article into the recently-viewed store the hub's chips
 *      read (same localStorage key the old inline script used, so history
 *      survives the rebuild).
 *   2. Log of_help_article_view once per page view, which is the popularity
 *      half of the article ranking the Insights Help tab will do (added
 *      2026-08-03).
 *   3. Drive the verdict widget: Yes ends politely, No reveals the loud
 *      contact CTA (spec Q3 loud-on-failure) and logs of_help_verdict.
 *
 * Loaded from layout/theme.liquid ONLY (0fad323 rule), deferred, gated to
 * request.page_type == 'metaobject'. Fail-open: if window.OFTrack is
 * missing the CTA still reveals; it just does not log (same self-gating
 * contract as the search-log beacon).
 */
(function () {
  'use strict';

  var RECENTS_KEY = 'hc_recent_articles_v1';

  var root = document.querySelector('[data-of-hc-article-root]');
  if (root) {
    try {
      var cur = {
        url: root.getAttribute('data-of-hc-url') || window.location.pathname,
        title: root.getAttribute('data-of-hc-title') || document.title,
        ts: Date.now()
      };
      var list = [];
      try { list = JSON.parse(localStorage.getItem(RECENTS_KEY) || '[]'); } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      list = list.filter(function (x) { return x && x.url !== cur.url; });
      list.unshift(cur);
      if (list.length > 10) list = list.slice(0, 10);
      localStorage.setItem(RECENTS_KEY, JSON.stringify(list));
    } catch (e) { /* storage blocked: recents just do not persist */ }
  }

  var verdict = document.querySelector('[data-of-hc-verdict]');
  if (!verdict) return;

  /* THE VIEW EVENT (2026-08-03). A verdict tells you how an article did for
   * the handful of people who voted; a view tells you how many people the
   * article was worth writing for at all. The Insights Help tab ranks on
   * both, so both have to exist in the log.
   *
   * The handle and the category are read from the verdict element because
   * that is the only markup on the page that carries them (the recents root
   * carries a url and a title, which are display strings, not the system
   * handle the log keys on). Both attributes ship together in
   * sections/help-article.liquid, so reading them from one element cannot
   * half-work.
   *
   * once() rather than event(): this IIFE already runs a single time per
   * page, but this repo has a documented history of a script being loaded
   * two and three times over (commit 0fad323), and a doubled view count is
   * the exact failure a popularity ranking cannot survive. The key is the
   * handle, so the dedupe is per article rather than per page load.
   *
   * Fail-open, same contract as the verdict below: no OFTrack, no log, and
   * nothing else on the page notices.
   */
  var articleHandle = verdict.getAttribute('data-of-hc-article') || '';
  var articleCategory = verdict.getAttribute('data-of-hc-category') || '';
  if (window.OFTrack && articleHandle) {
    OFTrack.once('of_help_article_view', articleHandle, {
      article: articleHandle,
      category: articleCategory
    });
  }

  var fired = false;
  var votes = verdict.querySelectorAll('[data-of-hc-vote]');
  for (var i = 0; i < votes.length; i++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-of-hc-vote') === 'no' ? 'no' : 'yes';
        verdict.classList.remove('of-hc-answered-yes', 'of-hc-answered-no');
        verdict.classList.add(v === 'no' ? 'of-hc-answered-no' : 'of-hc-answered-yes');
        /* Accessibility (2026-08-01 review, P2): clicking a vote hides the
         * button group, so focus would otherwise be stranded in
         * display:none content and the change would go unannounced. Both
         * revealed blocks are role="status" aria-live="polite"; focus goes
         * to the first CTA when there is one (No), and to the revealed
         * message itself when there is not (Yes). Both targets carry
         * tabindex="-1" in the section. */
        var revealed = verdict.querySelector(v === 'no' ? '.of-hc-rescue' : '.of-hc-verdict-thanks');
        if (revealed) {
          var target = revealed.querySelector('a[href], button') || revealed;
          try { target.focus({ preventScroll: true }); } catch (e) { try { target.focus(); } catch (e2) { /* focus is a nicety */ } }
        }
        if (fired) return; /* the FIRST verdict is the measured one */
        fired = true;
        if (window.OFTrack) {
          OFTrack.event('of_help_verdict', {
            article: verdict.getAttribute('data-of-hc-article') || '',
            category: verdict.getAttribute('data-of-hc-category') || '',
            verdict: v
          });
        }
      });
    })(votes[i]);
  }
})();
